import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgFrameworkComponent } from 'ag-grid-angular/main';
import { ICellRendererParams } from 'ag-grid-community/main';

@Component({
    selector: 'tooltip-cell',
    template: require('./cell-tooltip-ag-renderer.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CellTooltipAgRendererComponent implements AgFrameworkComponent<ICellRendererParams> {

    public value: any;

    public agInit(row: ICellRendererParams): void {
        this.value = row.value;
    }
}